// DwsTooltip on touch screens: the hover guard (no tooltip from the mouse events a tap emulates) and the long press
// that opens a hover tooltip. Core: document listeners for every [data-dws-describedby] trigger on the page.

// After a tap the browser keeps a mouse position at the tapped point, and when the layout moves under it (a list opening,
// the page scrolling) Chromium sends pointerover / mouseover for a "mouse" to whatever now lies there - with no mouse in
// use. On a phone that opened an edge tooltip nobody touched, over the autocomplete list just tapped. Such made-up hover
// events on a tooltip trigger are stopped before Blazor sees them: a "mouse" pointerover while the last real pointer
// input was touch or pen, and the mouseover that follows it. A tap's own events (pointerType "touch") still show the
// tooltip, and any real mouse movement makes the mouse count again.
(function () {
    let lastPointerType = "mouse";
    let blockedTarget = null;

    const note = function (e) {
        if (e.isTrusted && e.pointerType) {
            lastPointerType = e.pointerType;
        }
    };

    window.addEventListener("pointerdown", note, true);
    window.addEventListener("pointermove", note, true);

    const onTrigger = function (e) {
        return e.target instanceof Element && e.target.closest("[data-dws-describedby]") !== null;
    };

    window.addEventListener("pointerover", function (e) {
        blockedTarget = null;

        if (e.pointerType === "mouse" && lastPointerType !== "mouse" && onTrigger(e)) {
            blockedTarget = e.target;
            e.stopImmediatePropagation();
        }
    }, true);

    window.addEventListener("mouseover", function (e) {
        if (blockedTarget !== null && e.target === blockedTarget) {
            blockedTarget = null;
            e.stopImmediatePropagation();
        }
    }, true);
})();

// Hover tooltips on touch: a long press (500 ms without moving) on a hover trigger opens its tooltip, the next touch
// elsewhere closes it. A tap still activates what is under the finger, so the tooltip of a button could not be read
// without pressing the button. The press is turned into the mouseover / mouseout the component already handles, and
// the click (and Android's context menu) that would follow the long press is swallowed once.
(function () {
    let press = null;
    let shown = null;
    let swallowUntil = 0;

    const cancel = function () {
        if (press) {
            clearTimeout(press.timer);
            press = null;
        }
    };

    window.addEventListener("pointerdown", function (e) {
        const target = e.target instanceof Element ? e.target : null;

        if (shown && !(target && shown.contains(target))) {
            shown.dispatchEvent(new MouseEvent("mouseout", { bubbles: true }));
            shown = null;
        }

        cancel();

        if (e.pointerType !== "touch" || !e.isPrimary || !target) {
            return;
        }

        const root = target.closest(".dws-tooltip-hover");

        if (!root) {
            return;
        }

        press = {
            id: e.pointerId,
            x: e.clientX,
            y: e.clientY,
            timer: setTimeout(function () {
                press = null;
                shown = root;
                swallowUntil = Date.now() + 1000;
                root.dispatchEvent(new MouseEvent("mouseover", { bubbles: true }));
            }, 500)
        };
    }, true);

    window.addEventListener("pointermove", function (e) {
        if (press && e.pointerId === press.id && Math.abs(e.clientX - press.x) + Math.abs(e.clientY - press.y) > 10) {
            cancel();
        }
    }, true);

    window.addEventListener("pointerup", cancel, true);
    window.addEventListener("pointercancel", cancel, true);

    const swallow = function (e) {
        if (shown && Date.now() < swallowUntil && e.target instanceof Element && shown.contains(e.target)) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    window.addEventListener("click", swallow, true);
    window.addEventListener("contextmenu", swallow, true);
})();
